<template>
    <div class="program-search">
          <el-select
                v-model="value"
                filterable
                remote
                reserve-keyword
                clearable
                :placeholder="$t('event.textbox.search_')"
                @change="selectionChange"
                :remote-method="remoteMethod"
                :loading="loading">
                <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.title"
                :value="item.id">
                </el-option>
            </el-select>
    </div>
</template>

<script>

import axios from 'axios';


export default {
    name: 'ProgramSearch',
    props: [ ],
    data() {
      return {
        options: [],
        value: [],
        loading: false,
      }
    },
    mounted() {
        
    },
    methods: {
      async remoteMethod(query) {
        if (query !== '') {
          this.loading = true;
          

            await axios
                .post("program/load", {
                searchTerm: query,
                skip: 0,
                take: 20
                })
                .then((res) => {
                    this.options = res.data.data.items;
                    this.loading = false;
                });


        } else {
          this.options = [];
        }
      },
      selectionChange(val) {
          this.$emit('programSearchChanged', val);
      },
       resetFilter()
      {
          this.value = null;
      }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ProgramSearch.vue